<div class="d-lg-none">
  <fgb-mobile-page-header pageTitle="quiz.page.banner" [showQr]="true" [backButtonLink]="'/games'"></fgb-mobile-page-header>
</div>

<div class="games-page-header-div" [ngClass]="isCorporate ? 'bg-corporate-primary' : 'bg-primary'">
  <div class="games-banner">
    <div class="container">
      <div class="games-banner-frame">
        <a class="games-banner-buttons d-lg-flex d-none text-white align-items-center" [routerLink]="['/games']">
          <i class="material-icons">chevron_left</i>
          <span class="font-size-14 fw-bold">{{ 'games.banner.back.title' | translate }}</span>
        </a>
        <div class="banner-img-container">
          <img [src]="'banners/trivia-banner.jpg' | contentAssetImage" alt="Games Banners" class="games-banner-banners" />
        </div>
      </div>
    </div>
  </div>
  <div class="games-nav-container">
    <div class="container">
      <fgb-game-nav>
        <a
          class="nav-item"
          [routerLink]="['/games/trivia']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <label class="mb-0 fw-bold">{{ 'games.nav.play' | translate }}</label>
        </a>
        <a
          class="nav-item"
          [routerLink]="['/games/trivia/leaderboard']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <label class="mb-0 fw-bold">{{ 'games.nav.leaderboard' | translate }}</label>
        </a>
      </fgb-game-nav>
    </div>
  </div>
</div>

<div class="games-content">
  <router-outlet></router-outlet>
</div>
